import { useEffect, useState } from 'react';
import { differenceInDays } from 'date-fns';
import { db } from './firebaseConfig';
import { collection, query, orderBy, where, getDocs, limit, startAfter } from 'firebase/firestore';
import { Link } from 'react-router-dom';



function Publicaciones() {
  const [services, setServices] = useState([]);
  const [lastDoc, setLastDoc] = useState(null); // Para paginación
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // Cargar datos (Reinicia la lista)
  const cargarDatos = async (isMore = false) => {
    setLoading(true);
    try {
      const constraints = [
        where('visible', '==', true),
        orderBy('creadoEn', 'desc'),
      ];

      // Si es "Cargar más", usamos startAfter
      if (isMore && lastDoc) {
        constraints.push(startAfter(lastDoc));
      }

      // Traer 50 de una, para que se sienta que carga "todo" pero protegiendo si crece mucho
      constraints.push(limit(50));

      const q = query(
        collection(db, 'services'),
        ...constraints
      );

      const snapshot = await getDocs(q);

      const newItems = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (isMore) {
        setServices(prev => [...prev, ...newItems]);
      } else {
        setServices(newItems);
      }

      const lastVisible = snapshot.docs[snapshot.docs.length - 1];
      setLastDoc(lastVisible);
      setHasMore(snapshot.docs.length === 50);

    } catch (error) {
      console.error("Error cargando perfiles:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    cargarDatos(false);
  }, []);

  const vips = services.filter(s => s.membresia === 'VIP');
  const semiVips = services.filter(s => s.membresia === 'Semi VIP');
  const gratuitos = services.filter(s => !s.membresia || s.membresia === 'Gratuito');

  return (
    <div className="mt-8">

      <p className="text-sm text-gray-400 mb-6 px-1">
        Mostrando últimos perfiles registrados
      </p>

      {/* SECCIÓN VIP (GRANDES) */}
      {vips.length > 0 && (
        <div className="flex flex-wrap justify-center gap-8 mb-12">
          {vips.map(service => (
            <div key={service.id} className="w-full max-w-[350px]">
              <OriginalProfileCard service={service} size="large" />
            </div>
          ))}
        </div>
      )}

      {/* SECCIÓN SEMI VIP (MEDIANOS) */}
      {semiVips.length > 0 && (
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {semiVips.map(service => (
            <div key={service.id} className="w-[180px] sm:w-[260px]">
              <OriginalProfileCard service={service} size="medium" />
            </div>
          ))}
        </div>
      )}

      {/* SECCIÓN GRATUITOS (PEQUEÑOS) */}
      {gratuitos.length > 0 && (
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {gratuitos.map(service => (
            <div key={service.id} className="w-[140px] sm:w-[180px]">
              <OriginalProfileCard service={service} size="small" />
            </div>
          ))}
        </div>
      )}

      {/* Botón Cargar Más */}
      {hasMore && !loading && (
        <div className="flex justify-center mb-12">
          <button
            onClick={() => cargarDatos(true)}
            className="bg-neutral-800 hover:bg-neutral-700 text-white font-bold py-3 px-8 rounded-full border border-neutral-600 transition shadow-lg text-sm"
          >
            Cargar más perfiles
          </button>
        </div>
      )}

      {loading && (
        <div className="text-center py-4">
          <span className="text-yellow-500 animate-pulse">Cargando...</span>
        </div>
      )}

      {!loading && services.length === 0 && (
        <div className="text-center py-20 bg-neutral-900/50 rounded-2xl border border-neutral-800">
          <p className="text-gray-500">No se encontraron perfiles con estos filtros.</p>
        </div>
      )}
    </div>
  );
}

// LA TARJETA ORIGINAL CON SUS ESTILOS PREERIDOS
function OriginalProfileCard({ service, size }) {
  const emojiPorRol = (rol) => {
    if (!rol) return '🎭';
    if (rol === 'Activo') return '🍆';
    if (rol === 'Pasivo') return '🍑';
    if (rol === 'Versátil') return '🔄';
    if (rol === 'Activo participativo') return '🍆✨';
    if (rol === 'Pasivo participativo') return '🍑✨';
    return '🎭';
  };

  const obtenerEtiquetaFecha = (creadoEn) => {
    if (!creadoEn) return null;
    const fecha = creadoEn.toDate ? creadoEn.toDate() : new Date(creadoEn);
    const dias = differenceInDays(new Date(), fecha);
    if (dias > 30) return null;
    if (dias === 0) return 'Hoy';
    return `${dias}d`;
  };

  // Ajustes de fuente por tamaño
  const nameSize = size === 'large' ? 'text-xl' : size === 'medium' ? 'text-base' : 'text-sm';
  const infoSize = size === 'large' ? 'text-sm' : 'text-[10px]';

  return (
    <Link
      to={`/perfil/${service.id}`}
      className="block relative group rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 transform bg-neutral-900 border border-white/5"
    >
      <div className="aspect-[3/4] w-full overflow-hidden relative">
        {service.portadaUrl ? (
          <img
            loading="lazy"
            src={service.portadaUrl}
            alt={service.nombre}
            className="w-full h-full object-cover object-center transition duration-500 ease-in-out group-hover:brightness-95 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full bg-neutral-800 animate-pulse" />
        )}

        {/* Badge Fecha */}
        {service.creadoEn && (() => {
          const label = obtenerEtiquetaFecha(service.creadoEn);
          return label ? (
            <div className="absolute top-2 left-2 bg-blue-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-lg z-10 transition-transform group-hover:scale-110">
              {label}
            </div>
          ) : null;
        })()}

        {/* Info Overlay */}
        {/* Name Overlay Top Gradient */}
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black via-black/60 to-transparent pointer-events-none z-10" />

        <div className="absolute bottom-12 left-3 z-20 transition-all duration-300 group-hover:-translate-y-1">
          <p className={`text-white font-bold leading-tight truncate drop-shadow-md ${nameSize}`}>
            {service.nombre}
          </p>
        </div>

        {/* Info Overlay Bottom - Tags */}
        <div className="absolute bottom-3 left-3 flex flex-wrap gap-2 text-[10px] font-bold tracking-wide z-20">
          {service.ciudad && (
            <span className="bg-black/60 backdrop-blur-sm text-white px-2 py-1 rounded-full border border-white/10 flex items-center gap-1 shadow-sm">
              📍 {service.ciudad}
            </span>
          )}
          {service.rol && (
            <span className="bg-neutral-800/80 backdrop-blur-sm text-white px-2 py-1 rounded-full border border-white/10 flex items-center gap-1 shadow-sm">
              {emojiPorRol(service.rol)} {service.rol}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

export default Publicaciones;
